import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../services/account.service";
export class AtividadeService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/atividades`, data, { headers: this.account.composeHeaders() });
    }
    uploadPhotos(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/atividades/upload-photos`, data, { headers: this.account.composeHeaders() });
    }
    read(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/atividade/${id}`, { headers: this.account.composeHeaders() });
    }
    getAtividadeDetailsAsync(mesano, areatecnicaid) {
        return this.http.get(`${SCAMP_API.accountApiV1}/atividades/${mesano}/${areatecnicaid}`, { headers: this.account.composeHeaders() });
    }
    update(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/atividade/${id}`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/atividade/${id}`, { headers: this.account.composeHeaders() });
    }
    list(equipamentoId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/atividades/${equipamentoId}`, { headers: this.account.composeHeaders() });
    }
    search(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/atividade-search`, data, { headers: this.account.composeHeaders() });
    }
    updateDataProximaExecucao(equipamentoId, periodicidadeId, proximaExecucaoAnterior, proximaExecucao) {
        return this.http.get(`${SCAMP_API.accountApiV1}/atividades/update-data/${equipamentoId}/${periodicidadeId}/${proximaExecucaoAnterior}/${proximaExecucao}`, { headers: this.account.composeHeaders() });
    }
    removePlanoExecucao(equipamentoId, periodicidadeId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/atividades/delete-plano/${equipamentoId}/${periodicidadeId}`, { headers: this.account.composeHeaders() });
    }
    exportarCalendarioMensalToExcel(mes, areaTecnicaId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/atividades/calendario-mensal/excel/${mes}/${areaTecnicaId}`, { headers: this.account.composeHeaders() });
    }
}
AtividadeService.ngInjectableDef = i0.defineInjectable({ factory: function AtividadeService_Factory() { return new AtividadeService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: AtividadeService, providedIn: "root" });
